define('SageDotCom/DataLayer/Xperience/elements',['require', 'exports', 'score_ccf/Xperience/Elements', 'jquery'],
    function (require, exports, elementPairsBaseModule, $) {
        var actionsExtended = $.extend({},
            elementPairsBaseModule.ElementPairs.actions,
            {
                // place any new actions here.
                '{CD26AD81-CEFB-4D74-AFC1-1763E0F5ABE0}': 'SageDotCom/DataLayer/Xperience/Actions/businessTypeSelect',
                '{0513EA5A-E4CE-4195-8780-97A23F2C5693}': 'SageDotCom/DataLayer/Xperience/Actions/businessTypeSelect',
                '{AE5883A4-6A02-4182-A992-DBF99E61E3E9}': 'SageDotCom/DataLayer/Xperience/Actions/socialConnect'

            });

        var conditionsExtended = $.extend({},
            elementPairsBaseModule.ElementPairs.conditions,
            {
                // place any new conditions here.
            });

        exports.ElementPairs = {
            actions: actionsExtended,
            conditions: conditionsExtended
        };
    });
